<template>
  <f7-page no-swipeback infinite @infinite="loadMore" :infinite-preloader="false" :infinite-distance="20">
    <f7-navbar>
      <f7-nav-left>
        <f7-link icon-ios="f7:menu" icon-md="material:menu" panel-open="left"/>
      </f7-nav-left>
      <f7-nav-title>{{$t('title.myRequests')}}</f7-nav-title>
      <f7-nav-right>
        <f7-link :href="links.makeRequest" @click="showWarning" icon-only icon-ios="f7:plus" icon-md="material:add"/>
      </f7-nav-right>
      <f7-subnavbar v-if="isManager" sliding>
        <f7-segmented>
          <f7-button :href="links.manageRequests" tab-link>{{$t('title.manage')}}</f7-button>
          <f7-button :href="links.myRequests" tab-link tab-link-active>{{$t('title.myRequests')}}</f7-button>
        </f7-segmented>
      </f7-subnavbar>
    </f7-navbar>
    <request-filter v-if="!noRequests" :budgets="budgets" @show-processed="showProcessed = $event"
                    @set-filter="filterBudgetId = $event"/>
    <f7-block>
      <p v-if="noRequests">
        {{$t('text.noMyRequests[0]')}}
        <f7-link :href="links.makeRequest">{{$t('text.noMyRequests[1]')}}</f7-link>
        {{$t('text.noMyRequests[2]')}}
      </p>
      <p v-else class="text-align-right">{{$tc('title.request', requests.length, {count: requests.length})}}</p>
    </f7-block>
    <f7-list v-show="!showProcessed">
      <f7-list-item v-for="req in displayedRequests" :key="req.id" :link="`${links.request}/${req.id}`"
                    :header="req.created | toDate"
                    :title="req.reason" :after="formatMoney(req.currency, req.amount)"
                    :footer="$t('label.pendingApproval')">
      </f7-list-item>
    </f7-list>
    <f7-list v-show="showProcessed">
      <f7-list-item v-for="req in displayedRequests" :key="req.id" :link="`${links.request}/${req.id}`"
                    :header="req.created | toDate"
                    :title="req.reason" :after="formatMoney(req.currency, req.amount)"
                    :footer="proccessedFooter(req)">
        <f7-icon slot="media" :f7="req | listIcon" :color="req | iconColor"/>
      </f7-list-item>
    </f7-list>
    <div v-show="showPreloader" class="preloader infinite-scroll-preloader"></div>
    <main-toolbar slot="fixed" :active="1"/>
  </f7-page>
</template>

<script>
  import helpers from '@/utils/helpers'
  import MainToolbar from '../components/main-toolbar'
  import RequestFilter from '@/components/request-filter'
  import requestList from '@/utils/request-list'

  export default {
    name: 'my-requests',
    components: {
      MainToolbar,
      RequestFilter
    },
    computed: {
      noRequests () {
        return this.myRequests.length === 0
      },
      requests () {
        const requests = this.showProcessed ? this.myProcessedRequests : this.myPendingRequests
        return this.filterBudgetId ? requests.filter(r => r.potId === this.filterBudgetId) : requests
      }
    },
    created () {
      this.$store.dispatch('requests/fetchOwn')
      this.$store.dispatch('fetchCard')
    },
    methods: {
      showWarning() {
        if (this.myCard.status === 'Suspended')
          this.$f7.dialog.alert('Your card is currently frozen. Please be aware that you won\'t be able to make any purchases with it.', '')
      }
    },
    mixins: [helpers, requestList]
  }
</script>

<style lang="scss" scoped>
</style>
